import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "regenerator-runtime/runtime";
import { store } from "./store";
import { createTheme, ThemeProvider } from "@mui/material";
import { Provider } from "react-redux";
export const config = window.REACT_APP_CONFIG;

const theme = createTheme({
  palette: {
    primary: {
      light: "#0B5983",
      main: "#00558B",
      dark: "#14385F",
      contrastText: "#fff",
    },
  },
});
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// if (process?.env?.NODE_ENV !== "production" && module.hot) {
//   module.hot.accept("./App", renderApp);
// }
